<div class="sp-width__full sp-grid__summary-8 sp-grid__gap sp-overflow__x-scroll">
  <app-shared-summary-item
    [item_label]="'ORDERS.SUMMARY_ALL_LABEL'"
    [item_value]="summary?.length?.toString() || '0'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
  <app-shared-summary-item
    [item_label]="'ORDERS.SUMMARY_STORE_REVIEW_LABEL'"
    [item_value]="summary?.store_review?.toString() || '0'"
    [item_class]="'sp-orders__status-store-review'"
    [label_class]="'sp-color__primary'"
    [value_class]="'sp-color__primary'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
  <app-shared-summary-item
    [item_label]="'ORDERS.SUMMARY_PENDING_LABEL'"
    [item_value]="summary?.pending?.toString() || '0'"
    [item_class]="'sp-orders__status-pending'"
    [label_class]="'sp-color__primary'"
    [value_class]="'sp-color__primary'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
  <app-shared-summary-item
    [item_label]="'ORDERS.SUMMARY_RUNNING_LABEL'"
    [item_value]="summary?.running?.toString() || '0'"
    [item_class]="'sp-orders__status-running'"
    [label_class]="'sp-color__accent-contrast'"
    [value_class]="'sp-color__accent-contrast'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
  <app-shared-summary-item
    [item_label]="'ORDERS.SUMMARY_COMPLETED_LABEL'"
    [item_value]="summary?.completed?.toString() || '0'"
    [item_class]="'sp-orders__status-completed'"
    [label_class]="'sp-color__accent-contrast'"
    [value_class]="'sp-color__accent-contrast'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
  <app-shared-summary-item
    [item_label]="'ORDERS.SUMMARY_REFUNDED_LABEL'"
    [item_value]="summary?.refunded?.toString() || '0'"
    [item_class]="'sp-orders__status-refunded'"
    [label_class]="'sp-color__accent-contrast'"
    [value_class]="'sp-color__accent-contrast'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
  <app-shared-summary-item
    [item_label]="'ORDERS.SUMMARY_CANCELED_LABEL'"
    [item_value]="summary?.canceled?.toString() || '0'"
    [item_class]="'sp-orders__status-canceled'"
    [label_class]="'sp-color__accent-contrast'"
    [value_class]="'sp-color__accent-contrast'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
  <app-shared-summary-item
    [item_label]="'ORDERS.SUMMARY_ARCHIVED_LABEL'"
    [item_value]="summary?.archived?.toString() || '0'"
    [item_class]="'sp-orders__status-archived'"
    [label_class]="'sp-color__accent-contrast'"
    [value_class]="'sp-color__accent-contrast'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
</div>
